import { Input, ViewParent } from 'angular-ts-decorators';
import { Observable } from 'rxjs';

/**
 * Class meant to provide {@link SwChangeWrapper} related features to be
 * inherited from.  Tries to notify parent component, before running the own
 * callback.
 */
export class SwChange {
  /**
   * Attribute with the callback.
   */
  @Input() public swChange: any;

  /**
   * Optional parent component.
   */
  @ViewParent('^^?') swEditableField: ng.INgModelController & {
    swChangeNext: (any) => any;
    showField$: Observable<boolean>;
  };

  /**
   * Optional parent component.
   */
  @ViewParent('^^?') swChangeWrapper: any;

  /**
   * checks for swChangeNext; and runs own callbacks
   * @param {Object} value
   * Value that was set to the element
   * @return {void} Nothing
   */
  public change(value: any) {
    if (
      this.swEditableField &&
      angular.isFunction(this.swEditableField.swChangeNext)
    ) {
      this.swEditableField.swChangeNext(value);
    }

    if (
      this.swChangeWrapper &&
      angular.isFunction(this.swChangeWrapper.change)
    ) {
      this.swChangeWrapper.change(value);
    }

    if (angular.isFunction(this.swChange)) {
      // TODO remove `date: value` & refactor uses of sw-date-picker
      return this.swChange({ value, date: value });
    }
  }
}
